import { useCallback, useState } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

export const useAuthV2ReCaptcha = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [isExecuting, setIsExecuting] = useState(false);
  const [lastError, setLastError] = useState(null);

  const executeReCaptchaWithAction = useCallback(
    async (action = "auth") => {
      if (!executeRecaptcha) {
        throw new Error("reCAPTCHA n'est pas initialisé");
      }

      setIsExecuting(true);
      setLastError(null);

      try {
        const token = await executeRecaptcha(action);
        setIsExecuting(false);
        return token;
      } catch (error) {
        setIsExecuting(false);
        const errorMessage =
          "Erreur lors de la vérification anti-robot. Veuillez réessayer.";
        setLastError(errorMessage);
        throw new Error(errorMessage);
      }
    },
    [executeRecaptcha],
  );

  const executeStartAuth = useCallback(() => {
    return executeReCaptchaWithAction("auth_start");
  }, [executeReCaptchaWithAction]);

  const executeRecovery = useCallback(() => {
    return executeReCaptchaWithAction("auth_recovery");
  }, [executeReCaptchaWithAction]);

  const executeChangeIdentifier = useCallback(() => {
    return executeReCaptchaWithAction("auth_change_identifier");
  }, [executeReCaptchaWithAction]);

  const executeSocialRegister = useCallback(() => {
    return executeReCaptchaWithAction("auth_social_register");
  }, [executeReCaptchaWithAction]);

  const executeSocialValidatePhone = useCallback(() => {
    return executeReCaptchaWithAction("auth_social_phone");
  }, [executeReCaptchaWithAction]);

  const clearError = useCallback(() => {
    setLastError(null);
  }, []);

  return {
    isExecuting,
    lastError,

    executeReCaptchaWithAction,

    executeStartAuth,
    executeRecovery,
    executeChangeIdentifier,
    executeSocialRegister,
    executeSocialValidatePhone,

    clearError,
  };
};

export default useAuthV2ReCaptcha;
